// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatInvitationAcceptBody = {
  chatInvitationId: string;
};

export type typeChatInvitationAcceptOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { chatId: string };
};

export type typeChatInvitationAcceptOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatInvitationAcceptOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatInvitationAcceptOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatInvitationAcceptBody = {
  type: "object",
  properties: {
    chatInvitationId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["chatInvitationId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatInvitationAccept(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatInvitationAcceptBody);
  }

  return async function postChatInvitationAccept(
    payload: typeChatInvitationAcceptBody,
  ): Promise<
    typeChatInvitationAcceptOutput200 | typeChatInvitationAcceptOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatInvitationAccept" failed before calling the network. #37cf9fbd1311`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#37cf9fbd1311" },
        },
        data: null,
      } as typeChatInvitationAcceptOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat-invitation/accept`,
      httpMethod: "POST",
      options,
    })) as
      typeChatInvitationAcceptOutput200 | typeChatInvitationAcceptOutput400;
  };
}
